class ExtendedVariantOption extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.optionLabel = this.querySelector('[option-label]');
    this.optionPrice = this.querySelector('[option-price]');
    this.optionPricePerDay = this.querySelector('[option-price-per-day]');
    this.optionBenefit = this.querySelector('[option-benefit]');
    this.benefitBadge = this.querySelector('.benefit-badge');
    this.priceList = this.querySelector('.price-list');
    this.variantHasQuantity = false;
    this.quantity = 1;
    if (this.optionPrice) {
      if (!window.optionPriceList) {
        window.optionPriceList = [];
      }
      window.optionPriceList.push(parseInt(this.optionPrice.getAttribute('option-price')));
    }
    if (this.optionLabel) this.quantityCheck();
    this.initBadges();
    this.setBenefitBadge();
  }

  quantityCheck() {
    const text = (this.optionLabel.textContent || '').trim();
    const match = text.match(/\b(\d+)\s*x\b/i);
    const n = match ? parseInt(match[1], 10) : NaN;
    const multi = Number.isFinite(n) && n > 1;
    this.variantHasQuantity = multi;
    this.toggleAttribute('variant-has-quantity', multi);
    this.quantity = n;
  }

  initBadges() {
    const eachLabel = this.getAttribute('translations');
    if (!this.variantHasQuantity || !this.optionPrice || !eachLabel) return;
    const span = document.createElement('span');
    span.classList.add('piece-badge');
    if (this.priceList) {
      const compareAtPriceEl = this.priceList.querySelector('compare-at-price');
      const salePriceEl = this.priceList.querySelector('sale-price');
      if (compareAtPriceEl) {
        compareAtPriceEl.textContent = this.formatCurrency((parseInt(this.optionPrice.getAttribute('option-compare-at-price'), 10) / parseInt(this.quantity, 10)) / 100);
      }
      if (salePriceEl) {
        salePriceEl.textContent = this.formatCurrency((parseInt(this.optionPrice.getAttribute('option-price'), 10) / parseInt(this.quantity, 10)) / 100);
      }
    }
    span.textContent = eachLabel;
    this.optionPrice.prepend(span);
  }

  formatCurrency(value) {
    const parts = new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).formatToParts(value);
    const symbol = parts.find((part) => part.type === "currency")?.value || "€";
    const number = parts
      .filter((part) => part.type !== "currency" && part.type !== "literal")
      .map((part) => part.value)
      .join("");
    return `${number}${symbol}`;
  }

  setBenefitBadge() {
    if (!this.optionBenefit || !window.optionPriceList) return;
    const lowestPrice = Math.min(...window.optionPriceList);
    const currentOffer = parseInt(this.optionPrice.getAttribute('option-price')) / parseInt(this.quantity);
    const benefit = (lowestPrice - currentOffer) * parseInt(this.quantity) / 100;
    const benefitCurrency = this.formatCurrency(benefit);
    if (benefit !== 0) {
      this.optionBenefit.textContent = `-${benefitCurrency}`;
    }
  }

  get translations() {
    return this.getAttribute('translations');
  }
}


if (!customElements.get('extended-variant-option')) {
  customElements.define('extended-variant-option', ExtendedVariantOption);
}
